// La liste des pages est passée à React, sur le même composant que les groupes
// (js/react/ecrans/Espaces.jsx). Voir `groupes.js` pour le détail du partage.
//
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import { Pages } from "../react/ecrans/Espaces.jsx";

export { CATEGORIES, categorieDe } from "../espaces-meta.js";
export { creerPage } from "./espaces-creer.js";

/** Seuls les administrateurs d'une page y publient : un groupe échange, une page parle. */
export const estAdminPage = (page) => page?.monRole === "admin";

export const rendre = vueReact(Pages);
